// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__86V3F","validationTips":"StatementDescriptor_validationTips__G0ehG"};